var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex justify-between items-center text-white py-1 rounded-3xl",class:[
    { 'disabled:opacity-50': _vm.disabledButton || _vm.disabled },
    _vm.bgClass,
    _vm.borderClass,
    _vm.padXClass,
    _vm.heigthClass
  ],attrs:{"disabled":_vm.disabledButton || _vm.disabled,"type":_vm.type},on:{"click":_vm.nextStep}},[_c('span',{staticClass:"whitespace-nowrap",class:[ _vm.textClass ]},[_vm._v(_vm._s(_vm.btnText))]),(_vm.disabled)?_c('Loader',{attrs:{"animation":true,"classes":"w-4 h-4 ml-3"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }